import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1006f724"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tab" }
const _hoisted_2 = { class: "tab-header" }
const _hoisted_3 = { class: "step-number" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "step-description" }, "DISPLAY TEXT", -1))
const _hoisted_5 = {
  key: 0,
  class: "text-customization-options"
}
const _hoisted_6 = {
  key: 0,
  class: "text-type"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-type-header" }, "TEXT OPTIONS", -1))
const _hoisted_8 = { class: "text-type-inputs" }
const _hoisted_9 = { class: "radio-input" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "ml-2" }, "FRONT ONLY", -1))
const _hoisted_11 = { class: "radio-input" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "ml-2" }, "FRONT & BACK", -1))
const _hoisted_13 = { class: "radio-input" }
const _hoisted_14 = { class: "inputs-wrapper" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-header" }, "ENTER YOUR TEXT", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-header" }, "CHOOSE YOUR FONT", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-header" }, "FONT COLOUR", -1))
const _hoisted_18 = { class: "color-options" }
const _hoisted_19 = ["onClick", "title"]
const _hoisted_20 = {
  key: 1,
  class: "inputs-wrapper"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-header" }, "ENTER YOUR TEXT FOR BACK SIDE", -1))
const _hoisted_22 = {
  key: 1,
  class: "notification"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, "STEP " + _toDisplayString(_ctx.activeSidebarOption ? _ctx.activeSidebarOption.stepNumber : ""), 1),
      _hoisted_4
    ]),
    (_ctx.textData)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_ctx.textData.type)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_RadioButton, {
                      modelValue: _ctx.textType,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.textType) = $event)),
                      onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onAddonChange())),
                      value: "front"
                    }, null, 8, ["modelValue"]),
                    _hoisted_10
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_RadioButton, {
                      modelValue: _ctx.textType,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.textType) = $event)),
                      onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onAddonChange())),
                      value: "front&back"
                    }, null, 8, ["modelValue"]),
                    _hoisted_12
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_RadioButton, {
                      disabled: 
                _ctx.textData.message2 !== null || _ctx.activeProductType !== 'beanie'
              ,
                      modelValue: _ctx.textType,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.textType) = $event)),
                      onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onAddonChange())),
                      value: "wrapped"
                    }, null, 8, ["disabled", "modelValue"]),
                    _createElementVNode("label", {
                      class: _normalizeClass([
                _ctx.activeProductType !== 'beanie' ? 'disabled' : '',
                'ml-2',
              ])
                    }, "WRAPPED TEXT", 2)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createVNode(_component_InputText, {
              type: "text",
              modelValue: _ctx.text_1,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.text_1) = $event)),
              class: "custom-input",
              placeholder: "Type something...",
              onInput: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onTextChange({ textAdjust: true }))),
              maxlength: _ctx.textType === 'wrapped' ? 24 : _ctx.maxChars
            }, null, 8, ["modelValue", "maxlength"]),
            (_ctx.text_2 !== null)
              ? (_openBlock(), _createBlock(_component_InputText, {
                  key: 0,
                  type: "text",
                  modelValue: _ctx.text_2,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.text_2) = $event)),
                  class: "custom-input",
                  placeholder: "Type something...",
                  onInput: _cache[9] || (_cache[9] = ($event: any) => (_ctx.onTextChange({ textAdjust: false }))),
                  maxlength: _ctx.maxChars
                }, null, 8, ["modelValue", "maxlength"]))
              : _createCommentVNode("", true),
            _hoisted_16,
            _createVNode(_component_Dropdown, {
              class: "custom-input",
              modelValue: _ctx.fontFamily,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.fontFamily) = $event)),
              options: _ctx.fonts,
              onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.onTextChange({ textAdjust: true }))),
              placeholder: "Select your font"
            }, null, 8, ["modelValue", "options"]),
            _hoisted_17,
            _createElementVNode("div", _hoisted_18, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.colorOptions, (color, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  onClick: ($event: any) => (_ctx.changeColor(color)),
                  class: "color-square",
                  style: _normalizeStyle({ 'background-color': color.value }),
                  title: color.name
                }, null, 12, _hoisted_19))
              }), 128))
            ])
          ]),
          (_ctx.textType === 'front&back' && _ctx.text_2 === null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _hoisted_21,
                _createVNode(_component_InputText, {
                  type: "text",
                  modelValue: _ctx.backSideText.message,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.backSideText.message) = $event)),
                  class: "custom-input",
                  placeholder: "Type something...",
                  onInput: _cache[13] || (_cache[13] = ($event: any) => (_ctx.onTextChange({ textAdjust: false }))),
                  maxlength: _ctx.maxChars
                }, null, 8, ["modelValue", "maxlength"])
              ]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_22, " Sorry, text customization is not available for this template "))
  ]))
}